import React from "react";
import PageHeader from "../components/PageHeader";
import { TOOLKITS } from "../data/mock";
import { Package, FileText, Download, CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ContactCTA from "../components/ContactCTA";

const ToolkitPage = () => (
  <>
    <PageHeader
      title="ISO Documentation Toolkits"
      subtitle="Ready-to-use manuals, procedures, formats and records for every major ISO standard   fully editable and customised to your business."
      crumbs={[{ label: "Toolkits" }]}
    />

    <section className="section-pad bg-white">
      <div className="lis-container">
        <div className="grid md:grid-cols-3 gap-6 mb-14">
          {[
            { icon: Package, title: "Complete Kits", text: "Manuals, policies, procedures, formats and records covering all standard clauses." },
            { icon: FileText, title: "Editable & Branded", text: "MS Word and Excel formats, easily rebranded and adapted to your organisation." },
            { icon: Download, title: "Instant Delivery", text: "Delivered digitally within hours of purchase, with lifetime updates." },
          ].map((f) => (
            <div key={f.title} className="p-6 rounded-2xl border border-slate-100 card-hover">
              <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
                <f.icon size={22} />
              </div>
              <h3 className="mt-4 font-semibold text-slate-900">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{f.text}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TOOLKITS.map((k) => (
            <div key={k.title} className="p-6 rounded-2xl border border-slate-100 card-hover bg-white flex flex-col">
              <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
                <Package size={22} />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{k.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{k.items}</p>
              <ul className="mt-4 space-y-2 text-sm">
                <li className="flex items-center gap-2 text-slate-700"><CheckCircle2 size={14} className="text-brand" /> {k.size}</li>
                <li className="flex items-center gap-2 text-slate-700"><CheckCircle2 size={14} className="text-brand" /> Format: {k.format}</li>
                <li className="flex items-center gap-2 text-slate-700"><CheckCircle2 size={14} className="text-brand" /> Lifetime updates</li>
              </ul>
              <Link to="/contact" className="btn-brand mt-5 justify-center">Request Sample <ArrowRight size={14} /></Link>
            </div>
          ))}
        </div>
      </div>
    </section>

    <ContactCTA />
  </>
);

export default ToolkitPage;
